import { createContext, useContext } from "react";
import type { useChatListModel } from "../core/useChatListModel";

/**
 * The one list model instance the web shell creates (see PortalChatPanel), shared by the list
 * pane AND the thread pane — the thread pane gates the open conversation on `inView`, so both
 * sides must read the same scope/unread/sticky state. Mobile calls the hook directly per screen.
 */
export type ChatListModel = ReturnType<typeof useChatListModel>;

export const ChatListModelContext = createContext<ChatListModel | null>(null);

export function useChatListModelContext(): ChatListModel {
  const value = useContext(ChatListModelContext);
  if (!value) throw new Error("useChatListModelContext must be used inside ChatListModelContext");
  return value;
}
